function mapToSemanticVersion(versionArr: number[]): number[] {
    const semanticVersion = [0, 0, 0];
    for (let index = 0; index < 3; index++) {
        if (index < versionArr.length) {
            semanticVersion[index] = versionArr[index];
        }
    }
    return semanticVersion;
}

/**
 * Returns true if the app version is lower than a given version
 *
 * @param appVersion {string} the current app version
 * @param versionToCompare {string} the version to compare with the current app version
 * @returns Returns true if the app version is lower than the version to compare, otherwise false or undefined
 * @throws Error if the version to compare is empty
 */
export function isAppVersionLower(
    appVersion: string,
    versionToCompare: string,
): boolean | undefined | never {
    if (appVersion.indexOf("0.99") > 0) {
        // whitelist internal build version - 0.99.999
        return false;
    }
    if (appVersion === "1.5") {
        // whitelist internal build version - 1.5
        return false;
    }
    if (appVersion.length === 0) return undefined;
    if (versionToCompare.length === 0) {
        throw new Error("Version to compare can't be empty!");
    }

    if (appVersion === versionToCompare) return false;

    const appVersionSlices = appVersion.split(".").map((value) => Number(value.trim()));
    const versionToCompareSlices = versionToCompare
        .split(".")
        .map((value) => Number(value.trim()));

    const [appMajor, appMinor, appPatch] = mapToSemanticVersion(appVersionSlices);
    const [major, minor, patch] = mapToSemanticVersion(versionToCompareSlices);

    return appPatch <= patch && appMinor <= minor && appMajor <= major;
}
